import { Component, OnInit, animate, trigger, transition, style, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NotasComponent } from './notas/notas.component';
import { SidebarComponent } from './sidebar/sidebar.component';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/switchMap';

import { VisorService } from '../services/visor.service';
import { SeoService } from '../services/seo.service';
import { UsercontrolService } from '../services/usercontrol.service';
import { UtilsService } from '../services/utils.service';

import { Documento } from '../models/documento';

declare var jQuery: any;

@Component({
  selector: 'app-articulo',
  templateUrl: './articulo.component.html',
  styleUrls: ['./articulo.component.css'],
  providers: [SeoService, UsercontrolService, UtilsService]
  // animations: [
  //   trigger('fadeInOut', [
  //     transition('void => *', [
  //       style({opacity:0}), //style only for transition transition (after transiton it removes)
  //       animate(1500, style({opacity:1})) // the new state of the transition(after transiton it removes)
  //     ]),
  //     transition('* => void', [
  //       animate(1500, style({opacity:0})) // the new state of the transition(after transiton it removes)
  //     ])
  //   ])
  // ]
})

export class ArticuloComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private visorService: VisorService,
    private seoService: SeoService,
    private userControlService: UsercontrolService,
    private utilsService: UtilsService
  ) { }

  blocksSource = [];
  blocksFiltered = [];
  ngTexts = [];
  documento: Documento = new Documento();
  nombreSimple: String;
  article: String;
  prevArt: String;
  nextArt: String;
  showaside: boolean = false;
  selectedGuid: string = "";
  scrolled: boolean = false;

  ngOnInit() {
    this.route.params.subscribe(params => {

      let ajcode = params['id'];
      let art = params['art'];
      let guid: string = params['guid'];

      if (!params.hasOwnProperty('id') || !params.hasOwnProperty('art')) {
        this.router.navigate(['default']);
        return;
      }

      this.nombreSimple = ajcode;
      this.article = art;
      this.showaside = false;
      this.selectedGuid = (guid) ? guid.toUpperCase() : guid;

      //this.seoService.setTitle('My awesome Title!!!');
      this.seoService.setMetaDescription(this.documento.Nombre + ', articulo: ' + art);
      //this.seoService.setMetaRobots('Index, Follow');

      if (typeof jQuery === "function")
        jQuery("body").mask("Cargando...");

      this.visorService.getBlocks(ajcode, art).subscribe(t => {
        this.blocksSource = t;

        this.nextArt = t.nextItem;
        this.prevArt = t.prevItem;

        this.documento.Codigo = ajcode;
        this.documento.Nombre = t.document.documentMetadata["@name"];

        this.blocksFiltered = t.blocks.filter(f => f.block["@article"] == art);
        this.blocksFiltered = this.blocksFiltered.filter(f => this.validateContent(f.block));

        if (typeof jQuery === "function")
          jQuery("body").unmask();

        this.visorService.setAjCode({
          Nombre: this.documento.Nombre,
          Codigo: this.documento.Codigo,
          Articulo: this.article
        });

        setTimeout(() => {
          if (typeof jQuery === "function")
            jQuery('[data-toggle="tooltip"]').tooltip();
        }, 2500)

        //this.visorService.checkSearchCount();
      });

      this.visorService.getBlocksFromArticle(ajcode, art);

      // this.userControlService.getUserControl('FindArticlesAddNote').subscribe(u => {
      //   if (typeof jQuery === "function")
      //     jQuery(".add-note-usercontrol").html(u);
      // });
    });
  }

  getModelText(model) {
    /*return [{ text: model.block["@GUID"] }];*/
    if (!model.block || !model.block.hasOwnProperty("@GUID")) return [];

    var formatUnit = {};

    if (Array.isArray(model.block.formatUnit)) {
      this.ngTexts = [];
      for (var i = 0, l = model.block.formatUnit.length; i < l; i++) {
        formatUnit = this.visorService.validateFormatUnit(model.block.formatUnit[i], model.block["@GUID"], this.nombreSimple, this.article);
        this.ngTexts.push(formatUnit);
      }
    } else {
      this.ngTexts = [];
      if (typeof model.block.formatUnit === "object") {
        formatUnit = this.visorService.validateFormatUnit(model.block.formatUnit, model.block["@GUID"], this.nombreSimple, this.article);
        this.ngTexts.push(formatUnit);
      } else {
        if (model.block.table) {
          var rows = model.block.table.row;
          var text = '<table width="100%" class="block-table"><tbody>';

          var len_j = rows.length;
          for (var j = 0; j < len_j; j++) {

            text = text + '<tr>';
            var rowCells = rows[j].cell;
            var len_k = rowCells.length;
            for (var k = 0; k < len_k; k++) {

              var fUnit = rowCells[k].block.formatUnit;

              if (typeof fUnit === "string") {
                text = text + '<td>' + fUnit + '</td>';
              } else if (typeof fUnit === "object") {

                text = text + '<td>';

                var formattedUnit = this.visorService.validateFormatUnit(fUnit, model.block["@GUID"], this.nombreSimple, this.article);
                //if(fUnit.url) {
                if (formattedUnit.url) {
                  text = text + ' <a href="' + formattedUnit.url + '"';
                  text = text + ' class="rj-reference-text btext"';
                  text = text + ' uib-tooltip="' + formattedUnit.tooltip + '"';
                  text = text + ' target="_blank" data-type="isText">';
                  var textValue = formattedUnit.text;
                  if (typeof textValue === "string") {
                    text = text + textValue.replace(/&lt;/gi, "< ").replace(/&gt;/gi, " >");
                  } else {
                    //text = text + textValue.join().replace(',', ', ');
                  }
                  text = text + '</a> ';
                } else if (typeof formattedUnit.text === "string") {
                  text = text + formattedUnit.text;
                } else if (Array.isArray(formattedUnit)) {

                  for (var flUCount = 0; flUCount < formattedUnit.length; flUCount++) {
                    var fLittleUnit = this.visorService.validateFormatUnit(formattedUnit[flUCount], model.block["@GUID"], this.nombreSimple, this.article);

                    if (fLittleUnit.url) {
                      text = text + ' <a href="' + fLittleUnit.url + '"';
                      text = text + ' class="rj-reference-text btext"';
                      text = text + ' uib-tooltip="' + fLittleUnit.tooltip + '"';
                      text = text + ' target="_blank" data-type="isText">';
                      var textLittleValue = fLittleUnit.text;
                      if (typeof textLittleValue === "string") {
                        text = text + textLittleValue.replace(/&lt;/gi, "< ").replace(/&gt;/gi, " >");
                      } else {
                        //text = text + textValue.join().replace(',', ', ');
                      }
                      text = text + '</a> ';
                    } else if (typeof fLittleUnit.text === "string") {
                      text = text + fLittleUnit.text;
                    }
                  }
                }

                text = text + '</td>';
              }
            }
            text = text + '</tr>';
          }
          text = text + '</tbody></table>';
          formatUnit = { text: text, isTable: true, guid: model.block["@GUID"] };
          this.ngTexts.push(formatUnit);
        }

        if (model.block.image) {
          formatUnit = { isImage: true, src: model.block.image["@location"], guid: model.block["@GUID"] };
          this.ngTexts.push(formatUnit); //404
        }
      }
    }

    return this.ngTexts;
  }

  validateContent(block) {
    var hasContent = false;
    if (block) {
      if (Array.isArray(block.formatUnit)) {
        for (var i = 0, l = block.formatUnit.length; i < l; i++) {
          var fUnit = block.formatUnit[i];

          if (fUnit.hasOwnProperty('#text')) {
            if (fUnit['#text'].length) {
              hasContent = true;
              break;
            }
          }

          if (fUnit.hasOwnProperty('text')) {
            if (fUnit['text'].length) {
              hasContent = true;
              break;
            }
          }
        }
      } else {
        var fUnitStr = block.formatUnit;

        if (fUnitStr && fUnitStr.hasOwnProperty('#text')) {
          if (fUnitStr['#text'].length) {
            hasContent = true;
          }
        }

        if (fUnitStr && fUnitStr.hasOwnProperty('text')) {
          if (fUnitStr['text'].length) {
            hasContent = true;
          }
        }

        if (block.hasOwnProperty('@GUID') && block.table) {
          hasContent = true;
        }

        if (block.hasOwnProperty('@GUID') && block.image) {
          hasContent = true;
        }
      }
    }

    return hasContent;
  }

  toggleAside() {
    this.showaside = !this.showaside;
  }

  isBlockSelected(block) {
    if (!block.hasOwnProperty('@GUID')) {
      return false;
    }

    let guidBlock = block["@GUID"];

    if (guidBlock === this.selectedGuid) {
      if (!this.scrolled) {
        this.scrolled = true;
        setTimeout(() => {
          let element = document.getElementById(this.selectedGuid);
          window.scrollTo(element.offsetLeft, element.offsetTop);
          //jQuery('html,body').scrollTo('#' + this.selectedGuid);
        }, 3000);
      }
    }

    return guidBlock === this.selectedGuid;
  }
}



// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/articulo/articulo.component.ts